import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 4,
        mt: 6,
        textAlign: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper'
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} Stuffed Animals Database. All hugs reserved. 🧸
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        No stuffed animals were harmed in the making of this website.
      </Typography>
    </Box>
  );
};

export default Footer; 